import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import AnalysisLayout from "../layout/AnalysisLayout";
import { useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDoubleLeft, faAngleDoubleRight, faRefresh } from "@fortawesome/free-solid-svg-icons";
import { faFolderOpen } from "@fortawesome/free-regular-svg-icons";
import { AppDispatch, RootState } from "../../redux/store";
import { resultQuery, setupQuery } from "../../redux/queryBuilderSlice";
import { getMetadata } from "../../redux/queryMetaSlice";
import { IconButton } from "../../components/button/IconButton";
import { Button } from "../../components/button/Button";
import SavedQueriesTab from "./SavedQueriesTab";
import QueryAttributes from "../layout/Query/QueryAttributes";
import ManageFolders from "./ManageFolders";
import Tree from "./FolderTree";
import { fetchFolderReports, fetchFolders, updateContextMenuVisibility } from "../../redux/folderSlice";
import { fetchSavedQueries, fetchSharedQueries } from "../../redux/saveSlice";
import { SavedQueriesList } from "./SavedQueriesList";

const QueryBuilder = (props: any) => {
    const dispatch = useDispatch<AppDispatch>();
    const [isLeftPanelExpanded, setIsLeftPanelExpanded] = useState(true);
    useEffect(() => {
		dispatch(fetchFolders());
        dispatch(fetchSavedQueries());
        dispatch(fetchSharedQueries());
        dispatch(fetchFolderReports());
    }, [dispatch]);

    return (
        <>
            <AnalysisLayout>
                <div className="query-builder-container saved-queries">

                    <div className="left-panel" onClick={() => dispatch(updateContextMenuVisibility(false))}>
                        <div className={isLeftPanelExpanded ? "left-panel-container" : ""}>
                            <div className="query-bar-header">
                                
                            </div>
                            <div className="left-panel-qa">
                            <Tree/>
                            </div>
                        </div>
                    </div>
                    <SavedQueriesTab>
                        <SavedQueriesList/>
                    </SavedQueriesTab>
                </div>
            </AnalysisLayout >
        </>
    );
};

export default QueryBuilder;
